import { useQuery } from '@tanstack/react-query';
import { getHeroImageByTag } from '@/services/cloudinary';

interface UseHeroImageByTagOptions {
  tag: string;
  enabled?: boolean;
}

export default function useGetHeroImageByTag({
  tag,
  enabled = true,
}: UseHeroImageByTagOptions) {
  return useQuery({
    queryKey: ['hero_image_by_tag', tag],
    queryFn: () => getHeroImageByTag(tag),
    enabled: !!tag && enabled,
    select: data =>
      data.resources.length > 0 ? data.resources[0].public_id : null,
  });
}
